import { render, staticRenderFns } from "./HomeAlignment.vue?vue&type=template&id=672a84bc&scoped=true&"
import script from "./HomeAlignment.vue?vue&type=script&lang=ts&"
export * from "./HomeAlignment.vue?vue&type=script&lang=ts&"
import style0 from "./HomeAlignment.vue?vue&type=style&index=0&id=672a84bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672a84bc",
  null
  
)

export default component.exports